import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import Axios from "axios";
import "./newserial.css";
import Barcode from "react-barcode";
import Spinner from "react-bootstrap/Spinner";
import RangeSelectModal from "./RangeSelectModal";

const Newserial = () => {
  const [data, setData] = useState([]);
  const [details, setDetails] = useState([]);
  const [modelData, setModeldata] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedRange, setSelectedRange] = useState({ start: "", end: "" });

  const [loadingRows, setLoadingRows] = useState(
    Array(details.length).fill(false)
  );
  const [selectedBatchID, setSelectedBatchID] = useState("");

 const handleExtraBarcodeClick = (batchID) => {
  console.log("ORIGINAL BATCH ID:", batchID);

  setShowModal(true);

  setSelectedBatchID(batchID);
};

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleRangeSelect = (start, end) => {
    console.log("Selected Range:", start, "-", end);
    setSelectedRange({ start, end });
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getOrder`).then((response) => {
      setData(response.data);
    });
  }, []);

  function generateRandomCode() {
    const characters =
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let randomCode = "";

    for (let i = 0; i < 8; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      randomCode += characters.charAt(randomIndex);
    }
    return randomCode;
  }

  const postRandomCodesToMongoDB = async () => {
    const batchIdKeyValues = [];

    for (let i = 0; i < storedValues.length; i++) {
      const key = storedValues[i];
      const randomCode = storedrandom[i];

      const batchId = key.split("-").slice(0, 3).join("-");

      const batchIdEntry = batchIdKeyValues.find(
        (entry) => entry.batchId === batchId
      );

      if (batchIdEntry) {
        batchIdEntry.keyValuePairs.push({ key, value: randomCode });
      } else {
        batchIdKeyValues.push({
          batchId,
          keyValuePairs: [{ key, value: randomCode }],
        });
      }
    }

    for (const entry of batchIdKeyValues) {
      try {
        await Axios.post(`${INVENTORY_API_BASE_URL}/storeRandomCode`, {
          batchId: entry.batchId,
          keyValuePairs: entry.keyValuePairs,
        });
        console.log(
          `Random codes for BatchID ${entry.batchId} stored successfully.`
        );
        window.location.reload();
      } catch (error) {
        console.error("Error storing random codes:", error);
      }
    }
  };

  const handleRowClick = (index) => {
    setSelectedRow(index);
    setLoadingRows((prevLoadingRows) => {
      const updatedLoadingRows = [...prevLoadingRows];
      updatedLoadingRows[index] = true;
      return updatedLoadingRows;
    });

    setTimeout(() => {
      setLoadingRows((prevLoadingRows) => {
        const updatedLoadingRows = [...prevLoadingRows];
        updatedLoadingRows[index] = false;
        return updatedLoadingRows;
      });
    }, 0); 
  };

  function getSkuByOrderId(orderid, index) {
    const matchingData = data.find((row) => row.orderid === orderid);
    if (matchingData) {
      const list = matchingData.updatedQuantity;
      const types = list.map((obj) => [
        obj.sku,
        obj.title,
        obj.approvedquantity,
        obj.batchid,
        obj.Medium,
      ]);
      console.log(types);
      setDetails(types);
    } else {
      setDetails([]);
    }

    setLoadingRows((prevLoadingRows) => {
      const updatedLoadingRows = [...prevLoadingRows];
      updatedLoadingRows[index] = true; 
      return updatedLoadingRows;
    });

    Axios.get(`${INVENTORY_API_BASE_URL}/getOrder/${orderid}`)
      .then((response) => {
        setModeldata(response.data);
        setLoadingRows((prevLoadingRows) => {
          const updatedLoadingRows = [...prevLoadingRows];
          updatedLoadingRows[index] = false; 
          return updatedLoadingRows;
        });
      })
      .catch((error) => {
        console.error(error);
        setLoadingRows((prevLoadingRows) => {
          const updatedLoadingRows = [...prevLoadingRows];
          updatedLoadingRows[index] = false; 
          return updatedLoadingRows;
        });
      });
  }

  const filteredData = data.filter((row) => row.ApprovalDate !== null);
  const storedValues = [];
  const storedrandom = [];

  return (
    <div className="generatebarcode-container">
      <h4 style={{ textAlign: "center" }}>Generate Book Serial Number</h4>
      <div>
        <div>
          <Table style={{ textAlign: "center" }}>
            <thead>
              <tr>
                <th>Order No</th>
                <th>Received Date</th>
                <th>SKU</th>
                <th>Quantity </th>
                <th>Serial Number</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((row, index) => (
                <tr key={row.orderid}>
                  <td>{row.orderid}</td>
                  <td>{formatDate(row.ApprovalDate)}</td>

                  <td>{row.list.length}</td>
                  <td>
                    {row.updatedQuantity
                      .map((item) => item.approvedquantity)
                      .reduce((acc, value) => acc + value)}
                  </td>
                  <td>
                    {loadingRows[index] ? (
                      <Spinner animation="border" variant="primary" />
                    ) : (
                      <button
                        type="button"
                        class="btn btn-primary"
                        onClick={(e) => getSkuByOrderId(row.orderid, index)}
                      >
                        click
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
      <div>
        <h2>Order Id: {modelData.orderid}</h2>
        <Table bordered>
          <thead>
            <tr>
              <th>Title</th>
              <th>SKU</th>
              <th>Medium</th>
              <th>Edition</th>
              <th>Quantity</th>
              <th>Batch ID</th>
              <th>Serial Number</th>
              <th>Extra Barcode</th>
            </tr>
          </thead>
          <tbody>
            {details.map((val, index) => {
              const title = val[1];
              const SKU = val[0];
              const Medium = val[4];
              const edition = val[7];
              const Quantity = val[2];
              const BatchID = val[3];
              return (
                <tr
                  key={index}
                  className={selectedRow === index ? "selected" : ""}
                >
                  <td>{title}</td>
                  <td>{SKU}</td>
                  <td>{Medium}</td>
                  <td>{edition}</td>
                  <td>{Quantity}</td>
                  <td>{BatchID}</td>
                  <td>
                    {loadingRows[index] ? (
                      <Spinner animation="border" variant="primary" size="sm" />
                    ) : (
                      <button
                        type="button"
                        class="btn btn-primary"
                        onClick={() => handleRowClick(index)}
                      >
                        Click
                      </button>
                    )}
                  </td>
                  <td>
                    <button
                      type="button"
                      onClick={() => handleExtraBarcodeClick(BatchID)}
                    >
                      Extra Barcode
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
       <RangeSelectModal
  show={showModal}
  handleClose={handleCloseModal}
  handleRangeSelect={handleRangeSelect}
  selectedBatchID={selectedBatchID}
/>
        <Table>
          {selectedRow !== null && (
            <tfoot>
              <tr>
                <th>Selected Title</th>
                <th>Selected SKU</th>
                <th>Selected Batch ID</th>
                <th>Serial Number</th>
                <th>Random Code</th>
              </tr>
              {Array(details[selectedRow][2])
                .fill("")
                .map((_, index) => {
                  const selectedid = `${details[selectedRow][3]}`;
                  const value = `${selectedid}-${index + 1}`;
                  storedValues.push(value);
                  const randomCode = generateRandomCode();
                  const value1 = randomCode;
                  storedrandom.push(value1);
                  const selectedSKU = `${details[selectedRow][0]}`;
                  const selectedTitle = `${details[selectedRow][1]}`;
                  return (
                    <tr key={index}>
                      <td>{selectedTitle}</td>
                      <td>{selectedSKU}</td>
                      <td>{selectedid}</td>
                      <td>{value}</td>
                      <td>{value1}</td>
                    </tr>
                  );
                })}
            </tfoot>
          )}
        </Table>
      </div>

      <button onClick={postRandomCodesToMongoDB}>Approved</button>
    </div>
  );
};

export default Newserial;